import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { Autocomplete } from '@material-ui/lab';
import { wsFindBy } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

//reemplazando valores de iniciales en estado

export default function ModalContac(props) {
  const contact = props.model;
  const [dataChanging, setDataChanging] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  const [zones, setZones] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  const [bureau, setBureau] = useState([]);
  async function listBureaus() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id, state: 'A', delete_at: null});
    if (response.success) setBureau(response.data);
  }

  useEffect(() => {
    if (contact.open) {
      listZones();
    }
  }, [contact.open]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setBureau([]);
      listBureaus();
    }
  }, [dataChanging.base_zone_id])


  useEffect(() => {
    if (zones.length > 0 && contact.base_zone_id) {
      handleChange("base_zone_id", String(contact.base_zone_id));
    }
  },[zones]);

  useEffect(() => {
    if (bureau.length > 0 && contact.base_bureau_id) {
      handleChange("base_bureau_id", String(contact.base_bureau_id));
    }
  },[bureau]);

  return (
    <Modal
      title="Nuevo Contacto"
      model={contact}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/contact-report"
      state
      dataForce={{
        base_zone_id: dataChanging.base_zone_id,
        base_bureau_id: dataChanging.base_bureau_id,
      }}
    >
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Tipo</InputLabel>
        <Select
          required
          value={dataChanging.type ?? contact.type ?? ''}
          onChange={(e) => handleChange('type', e.target.value)}
          inputProps={{ name: 'type' }}
        >
          <MenuItem value="N">Normal</MenuItem>
          <MenuItem value="S">Supervisor</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="ID Grupo"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        value={dataChanging.description ?? contact.description ?? ''}
        onChange={(e) => handleChange('description', e.target.value)}
      />
      <TextField
        label="Nombre contacto o Grupo"
        type="text"
        name="grupo_description"
        margin="normal"
        fullWidth
        value={dataChanging.grupo_description ?? contact.grupo_description ?? ''}
        onChange={(e) => handleChange('grupo_description', e.target.value)}
        required
      />
      <TextField
        label="Teléfono"
        type="text"
        name="phone"
        margin="normal"
        fullWidth
        value={dataChanging.phone ?? contact.phone ?? ''}
        onChange={(e) => handleChange('phone', e.target.value)}
      />
      <TextField
        label="Correo"
        type="text"
        name="email"
        margin="normal"
        fullWidth
        value={dataChanging.email ?? contact.email ?? ''}
        onChange={(e) => handleChange('email', e.target.value)}
      />
      <Autocomplete
        disableClearable
        options={zones}
        getOptionLabel={(item) => `${item.description}`}
        renderInput={(params) => (
          <TextField {...params} label="Zona" margin="normal" fullWidth />
        )}
        onChange={(e, item) => { handleChange('base_zone_id', item?.id);}}
        value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null}
        style={{ flexGrow: 1, marginRight: '10px' }}
      />
      <Autocomplete
        disableClearable
        options={bureau}
        getOptionLabel={(item) => `${item.description}`}
        renderInput={(params) => (
          <TextField {...params} label="Mesa" margin="normal" fullWidth />
        )}
        onChange={(e, item) => { handleChange('base_bureau_id', item?.id);}}
        value={bureau.find((bureau) => String(bureau.id) === String(dataChanging.base_bureau_id)) || null}
        style={{ flexGrow: 1, marginRight: '10px' }}
      />

    </Modal>
  );
}